import { getBackboneWindow } from '../getBackboneWindow'

/**
 * Attempt to moment using the Backbone `MomentsBase` global module. If not available,
 * fall back to a direct window navigation.
 */
export const navigateWithMomentsBase = (
  url: string,
  { trigger }: { trigger: boolean }
) => {
  try {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ;(getBackboneWindow().MomentsBase as any).navigate(url, { trigger })
  } catch {
    window.location.assign(url)
  }
}
